import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import NotFound from 'srcReact/components/common2/NotFound'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import { groupHomeActions } from 'srcReact/GroupHomePage'
import NewFeed from 'srcReact/components/common2/NewFeed'
import styles from './styles.module.scss'
import FeedsTabContent from 'srcReact/components/common2/FeedsTabContent'
import FileNavigationPopup from 'srcReact/components/common2/FileNavigationPopup'
import Spinner from 'srcReact/components/common2/Spinner'
import Pill from 'srcReact/components/common2/Pill'
import { commonActions } from 'srcReact/components'
import Info from './components/Info'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { commonFeedActions } from 'srcReact/components/common2/FeedsTabContent/actions'
import PendingMessageCount from 'srcReact/components/common2/FeedsTabContent/components/PendingMessageCount'

export default function Feeds({
  groupId,
  isGroupVisible,
  isMemberOfGroup,
  isGroupOrganizer,
  feedIdToScroll,
  setFeedIdToScroll
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })
  const [isFilesOwner, setIsFilesOwner] = useState(false)
  const [pendingMessgeCount, setPendingMessgeCount] = useState(0)
  const [apiTriggeredForNewContent, setApiTriggeredForNewContent] = useState(false)

  const {
    login: { user: loggedInUser },
    organization: {
      header: { newsfeed }
    },
    common: { isMobile, tagUsersList, filesCreation },
    commonNewsfeed: {
      newsFeedId,
      feeds: { list, stats, loading: loadingFeeds, success: loadedFeeds },
      scrollToPost
    },
    groupHome: { group, loadingSendMessage, isMessagePosted, message_draft, groupOrganizer }
  } = useSelector((state) => state)

  useEffect(() => {
    if (group && isGroupVisible) {
      dispatch(commonActions.getTagUsers('group', groupId))
      dispatch(commonFeedActions.getFeeds('group', groupId, pagination, false))
    }
  }, [])

  useEffect(() => {
    if (newsfeed?.new_content === 1) {
      dispatch(commonFeedActions.getFeeds('group', groupId, pagination, true))
      setApiTriggeredForNewContent(true)
    } else if (newsfeed?.background_message_posting_count > 0) {
      //this reducer data (newsfeedid and count) will be used file modal if open
      dispatch(commonFeedActions.setPendingMessageCount(newsFeedId, newsfeed.background_message_posting_count))
      setPendingMessgeCount(newsfeed.background_message_posting_count)
    } else {
      dispatch(commonFeedActions.setPendingMessageCount(newsFeedId, newsfeed?.background_message_posting_count))
      setPendingMessgeCount(0)
    }
  }, [newsfeed?.new_content, newsfeed?.background_message_posting_count])

  useEffect(() => {
    // once newsfeed list is loaded(after called on organization.header.newsfeed.new_content becoming 1),
    // set pending message count to background_message_posting_count
    if (loadedFeeds && apiTriggeredForNewContent) {
      setApiTriggeredForNewContent(false)
      setPendingMessgeCount(newsfeed?.background_message_posting_count)
      dispatch(commonFeedActions.setPendingMessageCount(newsFeedId, newsfeed?.background_message_posting_count))
    }
  }, [loadedFeeds, apiTriggeredForNewContent, newsfeed?.background_message_posting_count])

  const getCurrentQuantity = () => {
    return stats.nextOffset < appConstantSettings.PAGINATION_QUANTITY
      ? appConstantSettings.PAGINATION_QUANTITY
      : stats.nextOffset
  }

  const lastFeedRef = useInfinitScroll(
    loadingFeeds,
    stats && stats.remaining,
    stats && stats.nextOffset,
    setPagination,
    [loadingFeeds, stats]
  )

  useEffect(() => {
    if (scrollToPost.newsfeed_id > 0 && scrollToPost.post_id > 0 && scrollToPost.content_offset > 0) {
      setPagination({ nextOffset: scrollToPost.content_offset, isPagination: true })
    }
  }, [scrollToPost])
  useEffect(() => {
    if (group && pagination.isPagination && isGroupVisible) {
      dispatch(commonFeedActions.getFeeds('group', groupId, pagination, false))
    }
  }, [dispatch, pagination])

  const deleteFile = (messageId, fileId) => {
    dispatch(groupHomeActions.deleteFileFromMessage(messageId, fileId, getCurrentQuantity()))
  }

  const handleAddCoorganizer = (userId) => {
    if (group) {
      dispatch(groupHomeActions.addStaffRole(groupId, userId, 'co-organizer'))
    }
  }
  const handleRemoveCoorganizer = (userId) => {
    if (group) {
      dispatch(groupHomeActions.removeStaffRole(groupId, userId, 'staff_members'))
    }
  }
  const handleRemoveFromGroup = (userId) => {
    if (group) {
      dispatch(groupHomeActions.removeFromGroup(groupId, userId))
    }
  }

  return (
    <div className={styles.feedsWrapper} id='feedsWrapper'>
      <Info t={t} isMemberOfGroup={isMemberOfGroup} description={group.description} />

      {!isMemberOfGroup && (group?.interests?.length > 0 || group.expertises?.length > 0) && (
        <div className={styles.interests}>
          <h2>
            {group.group_type === 'expertise'
              ? t('formlabel.expertise', { count: 0 })
              : t('formlabel.interest', { count: 0 })}
          </h2>
          <div className={styles.pill}>
            {group.group_type === 'interest' &&
              group?.interests?.map((i, idx) => (
                <Pill
                  type='interest'
                  selected={true}
                  askForAddToProfile={i.is_common_with_logged_user === 0}
                  dataId={i.id}
                  shared={i.is_common_with_logged_user === 1}
                  text={i.name}
                  key={idx}
                />
              ))}
            {group.group_type === 'expertise' &&
              group.expertises?.length > 0 &&
              group.expertises.map((i, idx) => (
                <Pill
                  selected={true}
                  shared={i.is_common_with_logged_user === 1}
                  type='expertise'
                  text={i.name}
                  key={idx}
                />
              ))}
          </div>
        </div>
      )}

      {isGroupVisible && isMemberOfGroup && (
        <NewFeed
          type='group'
          entity={group && { type: 'group', id: groupId, name: group.name, picture: group.picture }}
        />
      )}
      {!loadingFeeds && pendingMessgeCount > 0 && <PendingMessageCount from='feed' count={pendingMessgeCount} />}
      {isGroupVisible && !isMemberOfGroup && <NotFound title={t('groupHome.feed.noMemberOfGroup')} />}
      {!isGroupVisible ? (
        <NotFound
          className={styles.notFoundContainer}
          icon='mask-noBounding'
          {...(group.automatic_approval_to_join == 1
            ? {
                button: t('groupHome.header.joinGroup'),
                handleClick: () => dispatch(groupHomeActions.addMemberToGroup(groupId))
              }
            : group.automatic_approval_to_join == 0
            ? group.logged_user.invited_by === 'staffMember'
              ? {
                  button: t('global.acceptInvitation'),
                  handleClick: () => dispatch(groupHomeActions.acceptInvitation(groupId))
                }
              : group.logged_user.group_attending !== 'pending'
              ? {
                  button: t('groupHome.header.requestJoin'),
                  handleClick: () => dispatch(groupHomeActions.addMemberToGroup(groupId))
                }
              : null
            : null)}
          title={t('groupHome.feed.privateGroup')}>
          {group.logged_user.group_attending === 'pending' && (
            <div className={styles.pendingRequestBtn}>{t('groupHome.header.pendingRequest')}</div>
          )}
        </NotFound>
      ) : loadingFeeds && !pagination.isPagination ? (
        <Spinner />
      ) : !loadingFeeds && list && list.length === 0 ? (
        <NotFound title={t('groupHome.feed.noPost')} />
      ) : (
        <React.Fragment>
          <FeedsTabContent
            type='group'
            entity={group && { type: 'group', id: groupId, name: group.name, picture: group.picture }}
            lastFeedRef={lastFeedRef}
            isGroupOrganizer={isGroupOrganizer}
            isOrganizer={isGroupOrganizer}
            isMember={isMemberOfGroup}
            handleAddCoorganizer={handleAddCoorganizer}
            handleRemoveCoorganizer={handleRemoveCoorganizer}
            handleRemoveFromGroup={handleRemoveFromGroup}
            totalUsers={tagUsersList}
            feedIdToScroll={feedIdToScroll}
            setFeedIdToScroll={setFeedIdToScroll}
          />
          {loadingFeeds && pagination.isPagination && <Spinner />}
        </React.Fragment>
      )}
    </div>
  )
}
